"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFinancialDetailsEndpoint = getFinancialDetailsEndpoint;
function getFinancialDetailsEndpoint(contractId, productTypeId) {
    return `/contracts/${contractId}/${productTypeId}/financial-details`;
}
//# sourceMappingURL=financial-details.js.map